import React, { useState, useEffect } from "react";
import CurrentOpportunity_table from "./CurrentOpportunity_table";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { Modal, Button, Form } from "react-bootstrap";
import HTMLComponent from "../../../components/HtmlComponent";
import { FaSpinner } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { useDispatch } from "react-redux";

const Currentopportunity = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("NICE Opportunities - Internal Openings"));
  }, []);
  const [currentOpportunityList, setCurrentOpportunityList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [locationOption, setLocationOption] = useState([]);
  const [jobTitleOption, setJobtitleOption] = useState([]);
  const [statusOption, setStatusOption] = useState([]);
  const [reqId, setReqId] = useState([]);
  const [showApplyModal, setShowApplyModal] = useState(false);
  const [showJDModal, setShowJDModal] = useState(false);
  const [jDId, setJDId] = useState(0);
  const [jobDesData, setJobDesData] = useState();
  const [loadingData, setLoadingData] = useState(false);
  const [filterFormData, setFilterData] = useState([]);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const columns = {
    JobCode: { text: "Job Code", align: "start", visible: true },
    OpeningDate: { text: "Opening Date", align: "center", visible: true },
    PositionName: { text: "Job Title", align: "left", visible: true },
    ClientName: { text: "Client Name", align: "left", visible: true },
    Skills: { text: "Skills", align: "left", visible: true },
    JD: { text: "JD", align: "right", icon: "Icon3", visible: true },
    Experience: { text: "Experience", align: "center", visible: true },
    Location: { text: "Location", align: "left", visible: true },
    ROMPOC: { text: "RMG POC", align: "left", visible: true },
    ShowStatus: { text: "Status", align: "center", visible: false },
    Reason: { text: "Reason", align: "center", visible: false },
    AccountManager: {
      text: "Account Manager",
      align: "left",
      visible: false,
    },
    Priority: { text: "Priority", align: "center", visible: false },
    Apply: { text: "Apply", align: "center", type: "button", visible: true },
  };
  const defaultColumns = {
    // ID: true,
    AccountManager: true,
    JobCode: true,
    ClientName: true,
    JD: true,
    Location: true,
    Experience: true,
    OpeningDate: true,
    PositionName: true,
    Priority: false,
    ROMPOC: true,
    Reason: true,
    ShowStatus: true,
    AccountManager: false,
    Skills: true,
    Apply: true,
  };

  const handleGetData = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}current-opportunities?P_JobTitle=${filterFormData.find((o) => o.label === "Job Title")
          ? filterFormData.find((o) => o.label === "Job Title").value
          : 0
        }&P_Location=${filterFormData.find((o) => o.label === "Location")
          ? filterFormData.find((o) => o.label === "Location").value
          : 0
        }&P_Status=${filterFormData.find((o) => o.label === "Status")
          ? filterFormData.find((o) => o.label === "Status").value
          : 0
        }`
      );
      if (response.status === 200) {
        SetApiStatus(response?.status);
        const cleanedData = response.data;

        setCurrentOpportunityList(cleanedData.headers?.map(o => ({
          ...o, Experience: String(o.Experience).includes('Year') ? o.Experience : `${o.Experience} Years`
        })));

        const locationOptions = cleanedData?.location?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setLocationOption(locationOptions);
        const jobTitleOptions = cleanedData?.jobtitle?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setJobtitleOption(jobTitleOptions);
        const statusOptions = cleanedData?.status?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setStatusOption(statusOptions);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  useEffect(() => {
    fetchCurrentOpportunity();
  }, []);

  const fetchCurrentOpportunity = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}current-opportunities?P_JobTitle=&P_Location=&P_Status=`
      );
      if (response.status === 200) {
        SetApiStatus(response?.status);
        const cleanedData = response.data;

        setCurrentOpportunityList(cleanedData.headers?.map(o => ({
          ...o, Experience: String(o.Experience).includes('Year') ? o.Experience : `${o.Experience} Years`
        })));

        const locationOptions = cleanedData?.location?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setLocationOption(locationOptions);
        const jobTitleOptions = cleanedData?.jobtitle?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setJobtitleOption(jobTitleOptions);
        const statusOptions = cleanedData?.status?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setStatusOption(statusOptions);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };



  const handleApply = (id, item) => {
    setReqId(item.ID);
    setShowApplyModal(true);
  };

  const handleApplyModalClose = () => {
    setShowApplyModal(false);
  };

  const handleJD = (columnName, id) => {
    console.log("id:::::",id);
    
    setShowJDModal(true);
    setJDId(id.ID);
    setLoadingData(true);
    setJobDesData(null);
  };
  useEffect(() => {
    if (jDId) {
      fetchJDId(jDId);
    }
  }, [jDId]);

  const handleJDModalClose = () => {
    setShowJDModal(false);
    setJDId(null);
    setJobDesData(null);
    setLoadingData(false);
  };

  const fetchJDId = async (id) => {
      setLoading(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}jobdescription/${id}`
      );
      if (response.status === 200) {
        const cleanedData = response.data.jobdescription?.[0];
        setJobDesData(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch job Description. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching job Description:", error);
    }
  };

  const formDatas = [
    { name: "Location", type: "Select", options: [...locationOption] },
    { name: "Job Title", type: "Select", options: [...jobTitleOption] },
    { name: "Status", type: "Select", options: [...statusOption] },
  ];

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleApplyJob = async () => {
    setLoading(true);

    try {
      const response = await GetServiceCaller(
        `${API_URL}open-requirement/${reqId}`
      );
      if (response.status === 200) {
        const cleanedData = response.data;
        setShowApplyModal(false);
        setLoading(false);
        toast.success("Apply successfully");
        fetchCurrentOpportunity();
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const handleReset = () => {
    setFilterData([])
    fetchCurrentOpportunity()
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <CurrentOpportunity_table
              data={currentOpportunityList}
              isApiStatus={apiStatus}
              handleReset={handleReset}
              isRequiredStatus={true}
              isSrNoRequired={false}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon3={true}
              handleBtn={handleApply}
              isFilterRequired={true}
              isSorting={true}
              formDatas={formDatas}
              handleChange={handleChange}
              filterFormData={filterFormData}
              handleIconClick={handleJD}
              handleGetData={handleGetData}
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
                Icon2: <i className="bi bi-trash-fill icons"></i>,
                Icon3: <i className="bi bi-eye-fill icons"></i>,
                Icon4: <i className="bi bi-plus-square icons"></i>,
              }}
            />
          </div>
        </div>
      <Modal
  show={showApplyModal}
  onHide={handleApplyModalClose}
  centered
  dialogClassName="modal-md apply-modal"
>
  <div className="card rounded-4 border-0 overflow-hidden" style={{ boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)' }}>
    <Modal.Header className="border-0 pb-0 position-relative" style={{ backgroundColor: '#f8f9fa' }}>
      <Modal.Title className="w-100">
        <div className="d-flex justify-content-between align-items-center px-3">
          <p style={{
            fontSize: '18px',
            fontWeight: '700',
            color: '#2c3e50',
            margin: '0',
            letterSpacing: '0.5px'
          }}>
            Confirm Application
          </p>
          <button 
            type="button" 
            className="btn-close" 
            onClick={handleApplyModalClose}
            aria-label="Close"
            style={{
              fontSize: '12px',
              padding: '8px',
              backgroundSize: '10px',
              opacity: '0.7',
            }}
          />
        </div>
      </Modal.Title>
    </Modal.Header>

    <Modal.Body className="py-3 px-4">
      <div className="text-center">
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          backgroundColor: 'rgba(78, 84, 200, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 15px'
        }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#4e54c8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-briefcase"
          >
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
          </svg>
        </div>
        <h6 style={{
          fontWeight: '600',
          color: '#2c3e50',
          marginBottom: '20px',
          fontSize: '16px'
        }}>
          Are you sure you want to apply for this position?
        </h6>
      </div>
    </Modal.Body>

    <Modal.Footer className="border-0 pt-0 pb-3 px-4">
      <div className="d-flex justify-content-end w-100 gap-3">
        <button
          className="cancel-btn"
          onClick={handleApplyModalClose}
        >
          Cancel
        </button>
        <Button
          disabled={loading}
          className="custom-btn"
          onClick={handleApplyJob}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Applying...
            </>
          ) : (
            'Apply Now'
          )}
        </Button>
      </div>
    </Modal.Footer>
  </div>
</Modal>

        {/** JD Modal */}
        {showJDModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
              style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1050
    }}
          >
            <div className="modal-dialog modal-md" role="document">
              <div className="modal-content">
                <div className="modal-header" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #f0f0f0',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px 8px 0 0'
        }}>
                  <p
                  style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#27568B',
            margin: '0'
          }}
                  >
                    Job Description
                  </p>
                  <span className="me-2">
                    <i
                      className="bi bi-x-lg"
                      style={{ cursor: "pointer" }}
                      onClick={handleJDModalClose}
                    ></i>
                  </span>
                </div>

                <div
                  className="modal-body"
                  style={{
                    maxHeight: "60vh",
                    overflowY: "auto",
                    backgroundColor: "white",
                  }}
                >
                  {loading ? (
  <div className="text-center">
    <FaSpinner className="spinner" />
  </div>
) : !jobDesData || jobDesData.length === 0 || jobDesData[0] === null ? (
  <div className="text-center">No Data Found</div>
) : (
  <HTMLComponent html={jobDesData} />
)}

                </div>

                <div className="modal-footer d-flex justify-content-end">
                  <button className="cancel-btn" onClick={handleJDModalClose}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Currentopportunity;
